export function Reducer(state, action) {
  switch (action.type) {
    case "load":
      return {
        ...state,
        plans: action.plans,
      };
    default:
      throw new Error();
  }
}
